import { render } from "./HistoryPage.vue?vue&type=template&id=8d632c84&scoped=true"
import script from "./HistoryPage.vue?vue&type=script&lang=js"
export * from "./HistoryPage.vue?vue&type=script&lang=js"

import "./HistoryPage.vue?vue&type=style&index=0&id=8d632c84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d632c84"]])

export default __exports__